import { useState } from "react";
import { Form, FormDate, FormActions, FormInput } from "../Controls/Form";
import CertificationSearch from "../Views/CertificationSearch";
import UserData from "../Controls/UserData";
import { toast } from "react-toastify";

function emptyCertification() {
  return {
    ID: 0,
    CertificationID: 0,
    Name: "",
    ShortName: "",
    Abbreviation: "",
    OrganizationName: "",
    OrganizationID: 0,
    DateReceived: null,
  };
}

/**
 * Certification form body. Prefer CertificationEditModal for UI entry points.
 */
export default function CertificationEdit({ certificationId = 0, onClose }) {
  const id = Number.parseInt(certificationId, 10) || 0;
  const [userData] = useState(UserData.UserData() || {});
  const [certification, updateCertification] = useState(() => {
    if (!id) return emptyCertification();
    const found = (userData.certifications || []).find((c) => Number(c.ID || c.id) === id);
    return found ? { ...found } : emptyCertification();
  });

  function close() {
    onClose?.();
  }

  function onCertSelect(emp) {
    if (!emp) return;
    updateCertification({
      ...certification,
      CertificationID: emp.CertificationID ?? emp.ID ?? emp.id ?? 0,
      Name: emp.Name ?? emp.name ?? "",
      ShortName: emp.ShortName ?? emp.shortName ?? "",
      OrganizationID: emp.OrganizationID ?? emp.organizationID ?? 0,
      OrganizationName: emp.OrganizationName ?? emp.organizationName ?? "",
    });
  }

  async function onDoneAsync() {
    const catalogId = certification.CertificationID || certification.certificationID || 0;
    if (!catalogId) {
      toast.error("Please select a certification from the catalog");
      return;
    }

    const payload = {
      ID: certification.ID || certification.id || 0,
      CertificationID: catalogId,
      Name: certification.Name || "",
      ShortName: certification.ShortName || "",
      OrganizationID: certification.OrganizationID || 0,
      OrganizationName: certification.OrganizationName || "",
      DateReceived: certification.DateReceived || null,
    };

    const resp = await UserData.UpdateAsync("certifications", payload, true);
    if (resp && resp.ok) {
      await UserData.GetUserDataAsync();
      toast.success("Certification saved");
      close();
    } else {
      toast.error(resp?.message || "Failed to save certification");
    }
  }

  async function onDelete() {
    const personCertId = certification.ID || certification.id;
    if (!personCertId) return;
    const resp = await UserData.DeleteAsync("certifications", personCertId);
    if (resp && resp.result) {
      toast.success("Certification deleted");
      await UserData.GetUserDataAsync();
      close();
    } else {
      toast.error("Failed to delete certification");
    }
  }

  const hasSavedId = (certification.ID || certification.id || 0) > 0;

  return (
    <div className="cm-modal-embedded">
      <Form className="cm-modal-form" object={certification} onUpdate={updateCertification}>
        <CertificationSearch label="Name" object={certification} onSelect={onCertSelect} />
        <FormInput label="Short Name" field="ShortName" />
        <FormInput label="Issuing Agency" field="OrganizationName" />
        <FormDate label="Date Received" field="DateReceived" />
        <FormActions
          onSaveAsync={async () => {
            await onDoneAsync();
          }}
          onCancelAsync={async () => {
            close();
          }}
          onDeleteAsync={hasSavedId ? onDelete : undefined}
        />
      </Form>
    </div>
  );
}
